import { useState } from "react";

import styled from "styled-components";
// import { Space } from "antd";
import { GlassCard } from "components/App/styled";
import DataController from "pages/dashboard/Reports/DataController";
import Chart from "components/Chart";

export default function App() {
  const [data, setData] = useState(null);

  return (
    <Container>
      <DataController data={data} setData={setData} />
      {data && (
        <Grid>
          <GlassCard
            style={{
              padding: "16px 32px",
              marginBottom: 32,
              width: "45%",
              height: "64vh",
              alignItems: "center",
              display: "flex",
            }}
          >
            <Chart type="pie" data={data} />
          </GlassCard>
          <GlassCard
            style={{
              padding: "16px 32px",
              marginBottom: 32,
              width: "45%",
              height: "64vh",
              alignItems: "center",
              display: "flex",
            }}
          >
            <Chart type="line" data={data} />
          </GlassCard>
        </Grid>
      )}
    </Container>
  );
}
const Container = styled.div``;
const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
